import { Controller } from "@hotwired/stimulus"

// Saving a form nobody touched is a write and a flash for nothing, so the button
// stays out of reach until something actually differs from what was loaded.
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.loaded = this.#snapshot(this.#asLoaded())
    this.refresh()
  }

  refresh() {
    this.#enable(this.#snapshot(this.element) !== this.loaded)
  }

  // What the server rendered, not what the fields hold now: Turbo restores a page
  // from its cache with the edits still in it, and those are not saved yet.
  #asLoaded() {
    const form = this.element.cloneNode(true)
    form.reset()
    return form
  }

  #snapshot(form) {
    return new URLSearchParams(new FormData(form)).toString()
  }

  // ui/button paints its disabled state from aria-disabled, so the property alone
  // leaves a dead button looking live.
  #enable(enabled) {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = !enabled
    this.submitTarget.setAttribute("aria-disabled", String(!enabled))
  }
}
